import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import api from '@/axios';
import { GET_PURCHASE_ORDER_KEY } from '@/keys';
import type { PurchaseOrder } from '@/types/core/purchase-order/purchase-order';

export const getPurchaseOrder = async (id: string): Promise<PurchaseOrder> => {
  const response = await api.get<PurchaseOrder>(`/purchase-orders/${id}`);
  return response.data;
};

export const useGetPurchaseOrder = (
  id: string,
): UseSuspenseQueryResult<PurchaseOrder, Error> =>
  useSuspenseQuery({
    queryKey: [...GET_PURCHASE_ORDER_KEY, id],
    queryFn: () => getPurchaseOrder(id),
  });
